import React from 'react';
import img2 from '../../../components/online_expense_tracking_ppt_powerpoint_presentation_styles_ideas_cpb_slide01.jpg'
import img3 from '../../expense-guide-1.png'
import img4 from '../../money_saving_and_planning_ppt_infographics_Slide01.jpg'
import './Style.css'

const Sections = () => {
    return (
        <div>
            <div className="flex flex-wrap py-10">
                <div className=""></div>
                <div className="">
                    <img src={img2} alt="" />
                </div>
            </div>
            {/* sections */}
            <div className="flex flex-wrap py-12 mx-auto max-w-[900px] justify-around p-4">
                <div className="max-w-[400px]">
                    <h2 className='text-2xl font-semibold'>Saving Management</h2>
                    <p className='py-4 mt-4'>Saving tracking is part of creating a budget and is simply a way for teams to monitor how much they are spending. Budget tracking helps teams monitor how much budget has been spent.</p>
                </div>
                <div className="max-w-[450px]">
                    <img className='max-w-[450px]' src={img3} alt="" />
                </div>
            </div>
            {/* section */}
            <div className="section6 py-12">
            <div className="section6-info">
                <p>Financial savings management refers to the process of estimating savings based on factors such as tracking savings, planning well, and mapping the same. Thus, this helps organizations in controlling spends and achieving savings by having a clear picture of accounts and planning their strategies accordingly.</p>  
                <button className='btn btn-sm btn-outline mt-4'>Read More</button>   
                </div> 
                </div>
                {/*last-section  */}
                <div className="flex flex-wrap py-12 max-w-[1100px] mx-auto justify-center gap-5">
                    <div className="max-w-[530px]">
                        <img className='max-w-[530px]' src={img4} alt="" />
                    </div>
                    <div className="max-w-[350px] lg:mt-16">
                        <h2 className='text-2xl font-semibold py-2'>Money management refers to</h2>
                        <p>Saving and investing are both important components of a healthy financial plan. Saving provides a safety net and a way to achieve short-term goals, while investing has the potential for higher long-term returns and can help achieve long-term financial goals. However, investing also comes with the risk of losing money.</p>
                    </div>
                </div>
            
           
        </div>
    );
};

export default Sections;